import { render, staticRenderFns } from "./bulk-lpn.vue?vue&type=template&id=25f56e7f&scoped=true&"
import script from "./js/bulk-lpn.js?vue&type=script&lang=js&"
export * from "./js/bulk-lpn.js?vue&type=script&lang=js&"
import style0 from "./bulk-lpn.vue?vue&type=style&index=0&id=25f56e7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f56e7f",
  null
  
)

export default component.exports